export const integrations = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',
  NavSidebar: {},
  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'integrations', integrationCategory: s.root.integrationCategory || 'all' })) } return false } })() },

  MainContent: {
    flow: 'y',
    flex: '1',
    overflow: 'auto',

    TopBar: {},

    ContentArea: {
      flow: 'y',
      gap: 'B',
      padding: 'B',
      flex: '1',
      '@mobileL': { padding: 'A' },

      PageTitle: { tag: 'h2', text: '{{ integrations2 | polyglot }}', fontSize: 'C', fontWeight: '700', color: 'inkText', letterSpacing: '-0.02em' },

      // ─── FILTER BAR ──────────────────────────────
      IntegrationFilterBar: {
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        paddingBottom: 'A',
        borderBottom: '1px solid inkBorder',

        PillAll: {
          text: '{{ allFilter | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', round: 'B', cursor: 'pointer',
          color: (el, s) => s.root.integrationCategory === 'all' ? 'ink' : 'inkMuted',
          background: (el, s) => s.root.integrationCategory === 'all' ? 'teal' : 'inkMid',
          onClick: (e, el, s) => s.root.update({ integrationCategory: 'all' })
        },
        PillEhr: {
          text: '{{ ehr | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', round: 'B', cursor: 'pointer',
          color: (el, s) => s.root.integrationCategory === 'ehr' ? 'ink' : 'inkMuted',
          background: (el, s) => s.root.integrationCategory === 'ehr' ? 'teal' : 'inkMid',
          onClick: (e, el, s) => s.root.update({ integrationCategory: 'ehr' })
        },
        PillLabs: {
          text: '{{ labs | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', round: 'B', cursor: 'pointer',
          color: (el, s) => s.root.integrationCategory === 'labs' ? 'ink' : 'inkMuted',
          background: (el, s) => s.root.integrationCategory === 'labs' ? 'teal' : 'inkMid',
          onClick: (e, el, s) => s.root.update({ integrationCategory: 'labs' })
        },
        PillInsurance: {
          text: '{{ insurance | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', round: 'B', cursor: 'pointer',
          color: (el, s) => s.root.integrationCategory === 'insurance' ? 'ink' : 'inkMuted',
          background: (el, s) => s.root.integrationCategory === 'insurance' ? 'teal' : 'inkMid',
          onClick: (e, el, s) => s.root.update({ integrationCategory: 'insurance' })
        },
        PillPayments: {
          text: '{{ payments | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', round: 'B', cursor: 'pointer',
          color: (el, s) => s.root.integrationCategory === 'payments' ? 'ink' : 'inkMuted',
          background: (el, s) => s.root.integrationCategory === 'payments' ? 'teal' : 'inkMid',
          onClick: (e, el, s) => s.root.update({ integrationCategory: 'payments' })
        },
        PillMessaging: {
          text: '{{ messaging | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', round: 'B', cursor: 'pointer',
          color: (el, s) => s.root.integrationCategory === 'messaging' ? 'ink' : 'inkMuted',
          background: (el, s) => s.root.integrationCategory === 'messaging' ? 'teal' : 'inkMid',
          onClick: (e, el, s) => s.root.update({ integrationCategory: 'messaging' })
        },
        PillTelehealth: {
          text: '{{ telehealth | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', round: 'B', cursor: 'pointer',
          color: (el, s) => s.root.integrationCategory === 'telehealth' ? 'ink' : 'inkMuted',
          background: (el, s) => s.root.integrationCategory === 'telehealth' ? 'teal' : 'inkMid',
          onClick: (e, el, s) => s.root.update({ integrationCategory: 'telehealth' })
        },
        PillScheduling: {
          text: '{{ schedulingReport | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', round: 'B', cursor: 'pointer',
          color: (el, s) => s.root.integrationCategory === 'scheduling' ? 'ink' : 'inkMuted',
          background: (el, s) => s.root.integrationCategory === 'scheduling' ? 'teal' : 'inkMid',
          onClick: (e, el, s) => s.root.update({ integrationCategory: 'scheduling' })
        },
        PillAi: {
          text: '{{ aiMl | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', round: 'B', cursor: 'pointer',
          color: (el, s) => s.root.integrationCategory === 'ai' ? 'ink' : 'inkMuted',
          background: (el, s) => s.root.integrationCategory === 'ai' ? 'teal' : 'inkMid',
          onClick: (e, el, s) => s.root.update({ integrationCategory: 'ai' })
        },
        PillWearables: {
          text: '{{ wearables | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', round: 'B', cursor: 'pointer',
          color: (el, s) => s.root.integrationCategory === 'wearables' ? 'ink' : 'inkMuted',
          background: (el, s) => s.root.integrationCategory === 'wearables' ? 'teal' : 'inkMid',
          onClick: (e, el, s) => s.root.update({ integrationCategory: 'wearables' })
        }
      },

      // ─── INTEGRATION grid ────────────────────────
      IntegrationGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: 'A',
        '@mobileL': { gridTemplateColumns: '1fr' },

        // EHR
        CardEpic: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'ehr',
          state: { name: 'Epic', category: 'EHR', logoUrl: 'https://www.google.com/s2/favicons?domain=epic.com&sz=128', status: 'connected' }
        },
        CardCerner: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'ehr',
          state: { name: 'Cerner', category: 'EHR', logoUrl: 'https://www.google.com/s2/favicons?domain=oracle.com&sz=128', status: 'connected' }
        },
        CardFhir: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'ehr',
          state: { name: 'Generic FHIR', category: 'EHR', logoUrl: 'https://www.google.com/s2/favicons?domain=hl7.org&sz=128', status: 'available' }
        },

        // Labs
        CardQuest: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'labs',
          state: { name: 'Quest Diagnostics', category: 'Labs', logoUrl: 'https://www.google.com/s2/favicons?domain=questdiagnostics.com&sz=128', status: 'connected' }
        },
        CardLabCorp: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'labs',
          state: { name: 'LabCorp', category: 'Labs', logoUrl: 'https://www.google.com/s2/favicons?domain=labcorp.com&sz=128', status: 'connected' }
        },
        CardLis: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'labs',
          state: { name: 'In-house LIS', category: 'Labs', status: 'connected' }
        },

        // Insurance (Georgian)
        CardAldagi: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'insurance',
          state: { name: 'Aldagi', category: 'Insurance', logoUrl: 'https://www.google.com/s2/favicons?domain=aldagi.ge&sz=128', status: 'connected' }
        },
        CardGpi: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'insurance',
          state: { name: 'GPI', category: 'Insurance', logoUrl: 'https://www.google.com/s2/favicons?domain=gpih.ge&sz=128', status: 'connected' }
        },
        CardImedi: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'insurance',
          state: { name: 'Imedi L', category: 'Insurance', logoUrl: 'https://www.google.com/s2/favicons?domain=imedil.ge&sz=128', status: 'disconnected' }
        },
        CardUnison: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'insurance',
          state: { name: 'Unison', category: 'Insurance', logoUrl: 'https://www.google.com/s2/favicons?domain=unison.ge&sz=128', status: 'available' }
        },

        // Payments
        CardTbc: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'payments',
          state: { name: 'TBC Pay', category: 'Payments', logoUrl: 'https://www.google.com/s2/favicons?domain=tbcbank.ge&sz=128', status: 'connected' }
        },
        CardBog: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'payments',
          state: { name: 'BOG iPay', category: 'Payments', logoUrl: 'https://www.google.com/s2/favicons?domain=bog.ge&sz=128', status: 'available' }
        },
        CardStripe: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'payments',
          state: { name: 'Stripe', category: 'Payments', logoUrl: 'https://www.google.com/s2/favicons?domain=stripe.com&sz=128', status: 'available' }
        },

        // Messaging
        CardWhatsapp: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'messaging',
          state: { name: 'WhatsApp', category: 'Messaging', logoUrl: 'https://www.google.com/s2/favicons?domain=whatsapp.com&sz=128', status: 'connected' }
        },
        CardSms: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'messaging',
          state: { name: 'SMS.ge', category: 'Messaging', status: 'connected' }
        },
        CardEmail: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'messaging',
          state: { name: 'Email SMTP', category: 'Messaging', status: 'connected' }
        },

        // Telehealth
        CardZoom: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'telehealth',
          state: { name: 'Zoom Health', category: 'Telehealth', logoUrl: 'https://www.google.com/s2/favicons?domain=zoom.us&sz=128', status: 'available' }
        },
        CardTwilio: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'telehealth',
          state: { name: 'Twilio', category: 'Telehealth', logoUrl: 'https://www.google.com/s2/favicons?domain=twilio.com&sz=128', status: 'available' }
        },

        // Scheduling
        CardGcal: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'scheduling',
          state: { name: 'Google Calendar', category: 'Scheduling', logoUrl: 'https://www.google.com/s2/favicons?domain=google.com&sz=128', status: 'connected' }
        },
        CardOutlook: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'scheduling',
          state: { name: 'Outlook Calendar', category: 'Scheduling', logoUrl: 'https://www.google.com/s2/favicons?domain=microsoft.com&sz=128', status: 'available' }
        },

        // AI/ML
        CardGemini: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'ai',
          state: { name: 'Google Gemini', category: 'AI/ML', logoUrl: 'https://www.google.com/s2/favicons?domain=deepmind.com&sz=128', status: 'connected' }
        },
        CardMedGemma: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'ai',
          state: { name: 'MedGemma', category: 'AI/ML', logoUrl: 'https://www.google.com/s2/favicons?domain=google.com&sz=128', status: 'available' }
        },
        CardDentiAi: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'ai',
          state: { name: 'Denti.AI', category: 'AI/ML', logoUrl: 'https://www.google.com/s2/favicons?domain=denti.ai&sz=128', status: 'available' }
        },
        CardOverjet: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'ai',
          state: { name: 'Overjet', category: 'AI/ML', logoUrl: 'https://www.google.com/s2/favicons?domain=overjet.com&sz=128', status: 'available' }
        },

        // Wearables
        CardHealthKit: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'wearables',
          state: { name: 'Apple HealthKit', category: 'Wearables', logoUrl: 'https://www.google.com/s2/favicons?domain=apple.com&sz=128', status: 'available' }
        },
        CardHealthConnect: {
          extends: 'IntegrationCard',
          show: (el, s) => s.root.integrationCategory === 'all' || s.root.integrationCategory === 'wearables',
          state: { name: 'Google Health Connect', category: 'Wearables', logoUrl: 'https://www.google.com/s2/favicons?domain=google.com&sz=128', status: 'available' }
        }
      }
    },
  },

  // ─── INTEGRATION MODAL ──────────────────────────
  IntegrationModal: {
    show: (el, s) => s.root.integrationModal?.open,
    position: 'fixed',
    top: '0', left: '0', right: '0', bottom: '0',
    zIndex: '1000',
    flow: 'x',
    align: 'center center',

    Overlay: {
      position: 'absolute', top: '0', left: '0', right: '0', bottom: '0',
      background: 'rgba(0,0,0,0.5)',
      cursor: 'pointer',
      on: { click: (e, el, s) => s.root.update({ integrationModal: { open: false } }) }
    },

    ModalCard: {
      position: 'relative',
      flow: 'y',
      gap: 'A',
      width: '100%',
      maxWidth: 'H',
      maxHeight: '90vh',
      overflow: 'auto',
      background: 'inkMid',
      round: 'B',
      padding: 'C',
      border: '1px solid inkBorder',
      boxShadow: '0 25px 50px rgba(0,0,0,0.25)',
      zIndex: '1001',

      CloseBtn: {
        tag: 'button',
        text: '{{ u2715 | polyglot }}',
        position: 'absolute', top: 'A', right: 'A',
        background: 'transparent', border: 'none', color: 'inkMuted',
        fontSize: 'A', cursor: 'pointer', padding: 'Y',
        ':hover': { color: 'inkText' },
        on: { click: (e, el, s) => s.root.update({ integrationModal: { open: false } }) }
      },

      ModalHeader: {
        flow: 'x', gap: 'Z', align: 'flex-start flex-start',
        HeaderLogo: {
          tag: 'img',
          src: (el, s) => {
            const m = s.root.integrationModal
            if (m?.logoUrl) return m.logoUrl
            return `https://ui-avatars.com/api/?name=${encodeURIComponent(m?.name || '?')}&background=f0f0f0&color=333&size=96&bold=true&format=svg`
          },
          width: 'A1', height: 'A1', round: 'Y', objectFit: 'contain', background: 'inkSurface', marginTop: 'X'
        },
        HeaderInfo: {
          flow: 'y', gap: 'Y',
          ModalName: { text: (el, s) => s.root.integrationModal?.name || '', fontSize: 'B', fontWeight: '700', color: 'inkText', lineHeight: '1' },
          ModalCategory: {
            flow: 'x', gap: 'Y', align: 'center',
            CatTag: { tag: 'span', text: (el, s) => s.root.integrationModal?.category || '', fontSize: 'Y', padding: 'X Y', round: 'B', background: 'inkSurface', color: 'inkMuted' },
            StatusDot: {
              flow: 'x', gap: 'X', align: 'center',
              Dot: { width: '8px', height: '8px', round: 'D',
                background: (el, s) => {
                  const st = s.root.integrationModal?.status
                  if (st === 'connected') return 'green'
                  if (st === 'disconnected') return 'red'
                  return 'inkMuted'
                }
              },
              StatusLabel: {
                fontSize: 'Y',
                text: (el, s) => {
                  const st = s.root.integrationModal?.status
                  if (st === 'connected') return 'Connected'
                  if (st === 'disconnected') return 'Disconnected'
                  return 'Not Installed'
                },
                color: (el, s) => {
                  const st = s.root.integrationModal?.status
                  if (st === 'connected') return 'green'
                  if (st === 'disconnected') return 'red'
                  return 'inkMuted'
                }
              }
            }
          }
        }
      },

      Divider: { width: '100%', height: '1px', background: 'inkBorder' },

      // ─── SETTINGS SECTION ──────────────
      SettingsSection: {
        flow: 'y', gap: 'Z',
        SectionTitle: { text: '{{ configuration | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText', margin: '- - Y -' },

        FieldApiKey: {
          flow: 'y', gap: 'Y',
          FieldLabel: { tag: 'label', text: '{{ apiKey | polyglot }}', fontSize: 'Y', fontWeight: '500', color: 'inkMuted' },
          FieldInput: { tag: 'input', type: 'text', placeholder: 'Enter API key...', padding: 'Z', round: 'Y', background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', fontSize: 'Z', width: '100%', outline: 'none' }
        },

        FieldEndpoint: {
          flow: 'y', gap: 'Y',
          FieldLabel: { tag: 'label', text: '{{ endpointUrl | polyglot }}', fontSize: 'Y', fontWeight: '500', color: 'inkMuted' },
          FieldInput: { tag: 'input', type: 'text', placeholder: 'https://api.example.com/v1', padding: 'Z', round: 'Y', background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', fontSize: 'Z', width: '100%', outline: 'none' }
        },

        FieldProtocol: {
          flow: 'y', gap: 'Y',
          FieldLabel: { tag: 'label', text: '{{ protocol | polyglot }}', fontSize: 'Y', fontWeight: '500', color: 'inkMuted' },
          FieldValue: { text: (el, s) => s.root.integrationModal?.protocol || 'REST API', fontSize: 'Z', color: 'inkSubtle', padding: 'Z', round: 'Y', background: 'inkSurface', border: '1px solid inkBorder' }
        }
      },

      // ─── SYNC SETTINGS ──────────────────
      SyncSection: {
        flow: 'y', gap: 'Z',
        show: (el, s) => s.root.integrationModal?.status === 'connected',
        SyncTitle: { text: '{{ syncSettings | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText', margin: '- - Y -' },

        SyncFrequency: {
          flow: 'x', align: 'center space-between', padding: 'Z', round: 'Y', background: 'inkSurface', border: '1px solid inkBorder',
          FreqLabel: { text: '{{ syncFrequency | polyglot }}', fontSize: 'Z', color: 'inkText' },
          FreqValue: {
            tag: 'select', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', fontSize: 'Y',
            Opt1: { tag: 'option', text: '{{ every5Minutes | polyglot }}' },
            Opt2: { tag: 'option', text: '{{ every15Minutes | polyglot }}' },
            Opt3: { tag: 'option', text: '{{ everyHour | polyglot }}' },
            Opt4: { tag: 'option', text: '{{ manualOnly | polyglot }}' }
          }
        },

        AutoSync: {
          flow: 'x', align: 'center space-between', padding: 'Z', round: 'Y', background: 'inkSurface', border: '1px solid inkBorder',
          AutoLabel: { text: '{{ autosyncOnChanges | polyglot }}', fontSize: 'Z', color: 'inkText' },
          AutoToggle: { tag: 'input', attr: { type: 'checkbox', checked: true }, width: 'Z', height: 'Z' }
        },

        LastSyncInfo: {
          flow: 'x', align: 'center space-between', padding: 'Z', round: 'Y', background: 'inkSurface', border: '1px solid inkBorder',
          SyncLabel: { text: '{{ lastSynced | polyglot }}', fontSize: 'Z', color: 'inkMuted' },
          SyncTime: { text: '2 minutes ago', fontSize: 'Z', color: 'green', fontWeight: '500' }
        }
      },

      // ─── ACTIONS ────────────────────────
      ModalActions: {
        flow: 'x', gap: 'Z', align: 'center flex-end', marginTop: 'Z',

        DisconnectBtn: {
          tag: 'button',
          show: (el, s) => s.root.integrationModal?.status === 'connected',
          text: '{{ disconnect | polyglot }}',
          fontSize: 'Z', fontWeight: '600', padding: 'Z A', round: 'Y',
          background: 'transparent', color: 'red', border: '1px solid red',
          cursor: 'pointer', transition: 'all 150ms ease',
          ':hover': { background: 'red.08' }
        },
        TestBtn: {
          tag: 'button',
          text: '{{ testConnection | polyglot }}',
          fontSize: 'Z', fontWeight: '600', padding: 'Z A', round: 'Y',
          background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder',
          cursor: 'pointer', transition: 'all 150ms ease',
          ':hover': { background: 'inkMid' }
        },
        SaveBtn: {
          tag: 'button',
          text: (el, s) => s.root.integrationModal?.status === 'connected' ? 'Save Changes' : 'Install & Connect',
          fontSize: 'Z', fontWeight: '600', padding: 'Z A', round: 'Y',
          background: 'inkText', color: 'inkMid', border: 'none',
          cursor: 'pointer', transition: 'opacity 150ms ease',
          ':hover': { opacity: '0.8' },
          on: { click: (e, el, s) => s.root.update({ integrationModal: { open: false } }) }
        }
      }
    }
  }
}
